import { type AxiosRequestConfig } from 'axios';

import { ApiTokenStorage } from '@/module/auth/utils/ApiTokenStorage';
import {
  getApplicationSessionId,
  getBrowserSessionId,
  getDeviceId,
} from '@/utils';

const apiToken = ApiTokenStorage.get();

export const axiosConfig: AxiosRequestConfig = {
  baseURL: `${process.env.NEXT_PUBLIC_SERVER_BASEURL}/api/`,
  headers: {
    'Content-Type': 'application/json',
    ...(apiToken?.length > 0 && {
      Authorization: `Bearer ${apiToken}`,
    }),
    'X-ZEP-Application-Session-Id': getApplicationSessionId(),
    'X-ZEP-Browser-Session-Id': getBrowserSessionId(),
    'X-ZEP-Device-Id': getDeviceId() ?? '',
  },
  timeout: 1000 * 15, // 15초 retry 는 react-query 레벨로 이관
  timeoutErrorMessage: 'API Request Real Timeout ',
  withCredentials: true,
};
